import PropTypes from "prop-types";

import EventDatasetName from "routes/meta_datasets/swoogo_events/EventDatasetName";
import useSwoogoEventDatasets from "routes/meta_datasets/swoogo_events/useSwoogoEventDatasets";

// Every cell asks for the links of the whole page, so the page loads them with
// one shared request.
const EventDatasetCell = ({ eventId, pageEventIds }) => {
  const { links } = useSwoogoEventDatasets(pageEventIds);
  const link = links.get(eventId);
  return link ? <EventDatasetName link={link} /> : "—";
};

EventDatasetCell.propTypes = {
  eventId: PropTypes.number.isRequired,
  pageEventIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export const EVENT_DATASET_COLUMN = {
  id: "Dataset",
  header: "Dataset",
  size: 200,
  enableSorting: false,
  cell: ({ row, table }) => (
    <EventDatasetCell
      eventId={row.original.id}
      pageEventIds={table
        .getRowModel()
        .rows.map(pageRow => pageRow.original.id)}
    />
  ),
};
